$ = require 'jquery'
h = require './helpers'

class PersonalPage
  applyStyles: ->
    console.log 'Применяю стили PersonalPage'
    $form = $('#aspnetForm')

#    $('body').addClass('partner_registration')

    $staff = $form.children()

#    h.h1('Регистрация партнера', 'h1-personal-page').appendTo $form
    [$row, $wrapper] = h.rowN(true, 'personal-page-content')
    $form.append $row

    $staff.appendTo $wrapper

#    $form.children().wrapAll('<div></div>')

module.exports = new PersonalPage